import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex bg-[#ad33ff3b]">
      {/* Left side - Auth forms */}
      <div className="mx-auto w-full max-w-lg my-auto ">
        {/* Theme switcher */}
        {/* <div className="flex justify-end mb-8">
          <ThemeSwitcher />
        </div> */}

        {/* Logo and title */}
        <div className="text-center mb-8">
          <img src="/images/logo.svg" alt="MST Buddy Logo" className="mx-auto h-12 w-auto" />
          {/* <h2 className="text-3xl font-bold tracking-tight">MST Buddy Admin</h2> */}
        </div>

        {/* Auth form content */}
        <Outlet />

        {/* Footer */}
        <div className="mt-8 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} MST Buddy Admin.</p>
        </div>
      </div>
    </div>
  );
}
